import React, { useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import "./styles.scss";
import Connect from "../../../shared/redux/Connect.hoc";

// ? Componets
import MiPerfil from '../../../components/private/Perfil/MiPerfil.component'
import CreateMensajeria from '../../../components/public/Mensajeria/Create.Mensajeria'
import SideMenuAcount from '../../../components/private/SideMenuAcount/SideMenuAcount.component'
import Mensajeria from '../../../containers/private/Mensajeria/Mensajeria.container'
const Perfil = ({ state, }) => {

  useEffect(() => {
    console.log("--Perfil.Container.useEffect--");
  }, []);

  return (
    <div className="Perfil-Container-Div">
      <div className="Perfil-Container-Div-Div">
        <SideMenuAcount />
        <Switch>
          <Route path="/" render={() => <CreateMensajeria />} exact />
          <Route path="/perfil" render={() => <MiPerfil />} exact />
          <Route path='/misservicios' render={() => <Mensajeria />} exact />

        </Switch>
      </div>
    </div>
  )
}

export default Connect(Perfil)